


































import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import SacCnhIvecoRequest from '@/model/request/SacCnhIvecoRequest'

@Component({components: {ItDateInput}})
export default class FilterSacCnhIveco extends Mixins(MixinMember) {
  @Prop({required: true}) value!: SacCnhIvecoRequest

}
